import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Page } from "../types";

type Params = {
  isMaintenanceMode: boolean;
  maintenanceModeDescription?: string;
  brandId: string;
  pageId: string;
};

export const updatePageMaintenanceMode = async ({
  brandId,
  pageId,
  isMaintenanceMode,
  maintenanceModeDescription,
}: Params) => {
  const collectionRef = collection(db, `brands/${brandId}/pages`);

  await updateDoc(doc(collectionRef, pageId), {
    isMaintenanceMode,
    maintenanceModeDescription,
    updatedAt: new Date(),
  });

  const pageSnapshot = await getDoc(doc(collectionRef, pageId));

  return pageSnapshot.data() as Page;
};
